import { __decorate, __param } from '../../../../../node_modules/tslib/tslib.es6.js';
import { IStatusbarService } from '../../services/statusbar/browser/statusbar.js';
import { MainContext } from '../common/extHost.protocol.js';
import { extHostNamedCustomer } from '../../services/extensions/common/extHostCustomers.js';
import { dispose } from 'monaco-editor/esm/vs/base/common/lifecycle.js';
import { getCodiconAriaLabel } from 'monaco-editor/esm/vs/base/common/iconLabels.js';
import { hash } from 'monaco-editor/esm/vs/base/common/hash.js';
let MainThreadStatusBar = class MainThreadStatusBar {
    constructor(_extHostContext, statusbarService) {
        this.statusbarService = statusbarService;
        this.entries = ( new Map());
    }
    dispose() {
        this.entries.forEach(entry => entry.accessor.dispose());
        this.entries.clear();
    }
    $setEntry(entryId, id, extensionId, name, text, tooltip, command, color, backgroundColor, alignLeft, priority, accessibilityInformation) {
        let ariaLabel;
        let role = undefined;
        if (accessibilityInformation) {
            ariaLabel = accessibilityInformation.label;
            role = accessibilityInformation.role;
        }
        else {
            ariaLabel = getCodiconAriaLabel(text);
            if (tooltip) {
                const tooltipString = typeof tooltip === 'string' ? tooltip : tooltip.value;
                ariaLabel += `, ${tooltipString}`;
            }
        }
        const entry = { name, text, tooltip, command, color, backgroundColor, ariaLabel, role };
        if (typeof priority === 'undefined') {
            priority = 0;
        }
        const alignment = alignLeft ? 0  : 1 ;
        let existingEntry = this.entries.get(entryId);
        if (existingEntry && (existingEntry.alignment !== alignment || existingEntry.priority !== priority)) {
            dispose(existingEntry.accessor);
            this.entries.delete(entryId);
            existingEntry = undefined;
        }
        if (!existingEntry) {
            let entryPriority;
            if (typeof extensionId === 'string') {
                entryPriority = { primary: priority, secondary: hash(extensionId) };
            }
            else {
                entryPriority = priority;
            }
            this.entries.set(entryId, { accessor: this.statusbarService.addEntry(entry, id, alignment, entryPriority), alignment, priority });
        }
        else {
            existingEntry.accessor.update(entry);
        }
    }
    $dispose(id) {
        const entry = this.entries.get(id);
        if (entry) {
            dispose(entry.accessor);
            this.entries.delete(id);
        }
    }
};
MainThreadStatusBar = __decorate([
    extHostNamedCustomer(MainContext.MainThreadStatusBar),
    ( __param(1, IStatusbarService))
], MainThreadStatusBar);
export { MainThreadStatusBar };
